/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

"use strict";

function SetPolyfill() {
  this._cache = [];
}

SetPolyfill.prototype.add = function(e) {
  if (this._cache.indexOf(e) === -1) {
    this._cache.push(e);
  }
};

SetPolyfill.prototype.forEach = function(cb) {
  this._cache.forEach(cb);
};

module.exports = SetPolyfill;



// WEBPACK FOOTER //
// ./modules/animated/SetPolyfill.js